// function taken from bosch/frontend-kit package

export const PAGINATION_DOTS = '...';

export const getPaginationArray = (
  activeIndex: number,
  maxPages: number,
  visiblePagesAroundCurrent: number = 1,
  minVisibleItems: number = 5,
): (number | string)[] => {
  const range = [];

  if (maxPages <= minVisibleItems) {
    return Array.from({ length: maxPages + 1 }, (_: unknown, i: number) => i).slice(1);
  }

  for (
    let i = Math.max(2, activeIndex - visiblePagesAroundCurrent);
    i <= Math.min(maxPages - 1, activeIndex + visiblePagesAroundCurrent);
    i += 1
  ) {
    range.push(i);
  }

  if (activeIndex - visiblePagesAroundCurrent > 3) {
    range.unshift(PAGINATION_DOTS);
  }

  if (activeIndex + visiblePagesAroundCurrent < maxPages - 2) {
    range.push(PAGINATION_DOTS);
  }

  if (range.length < minVisibleItems - 2 * visiblePagesAroundCurrent) {
    if (activeIndex < minVisibleItems - 2 * visiblePagesAroundCurrent) {
      range.length = 0;

      for (let i = 1; i <= minVisibleItems - 2; i += 1) {
        range.push(i);
      }

      range.push(PAGINATION_DOTS);
      range.push(maxPages);

      return range;
    }

    range.length = 0;
    range.push(1, PAGINATION_DOTS);

    const arrayBaseLength = range.length;

    for (let i = maxPages; i > maxPages - (minVisibleItems - arrayBaseLength); i -= 1) {
      range.splice(arrayBaseLength, 0, i);
    }

    return range;
  }

  range.unshift(1);
  range.push(maxPages);

  return range;
};
